if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"host","remotes":[{"alias":"fullbuy","name":"fullbuy","entry":"https://dom.ru/fullbuy/_next/static/chunks/remoteEntry.js","shareScope":"default"}]},
		chunkMatcher: function(chunkId) {return true},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}